import { ReactElement, useState } from 'react'
import { Flex, InputGroup, Select } from '@raskrask-dk/rr-components'
import { StyledPhoneField } from './styles'
import { useTranslation } from 'react-i18next'
import { PropsPhoneFieldTemplate } from './props'
import ReactCountryFlag from 'react-country-flag'

const PhoneFieldTemplate = ({
    customerType,
    landCodes,
    landCode,
    validPhone,
    changePhone,
    localPhone,
    onChangeLandCode,
    submitClickedWithMissingDetails,
}: PropsPhoneFieldTemplate): ReactElement => {
    const { t } = useTranslation()

    const placeholder =
        customerType === 'Company'
            ? t('details.form.phone.placeholder.company')
            : t('details.form.phone.placeholder.private')

    const [showError, setShowError] = useState(false)

    const hasError =
        (!validPhone && showError) ||
        (submitClickedWithMissingDetails && !validPhone)

    return (
        <StyledPhoneField>
            <Select
                customLabel={(p) => (
                    <Flex gap={4} alignItems="center">
                        <ReactCountryFlag countryCode={p.countryCode} svg />
                        {p.label}
                    </Flex>
                )}
                label={t('common:choose')}
                onChange={() => onChangeLandCode(landCode)}
                options={landCodes}
                value={landCode}
            />
            <InputGroup
                data-cy="customerPhone"
                error={hasError}
                helperText={hasError ? t('details.form.phone.error') : ''}
                label={placeholder}
                onBlur={() => setShowError(true)}
                onChange={(e) => {
                    const value = e.currentTarget.value
                    const characterArray = value.match(/[A-Za-z]/g)
                    // This IF is to not allow to user to write letters
                    if (characterArray === null) {
                        changePhone(e.currentTarget.value)
                    }
                }}
                type="text"
                value={localPhone?.toString()}
            />
        </StyledPhoneField>
    )
}

export default PhoneFieldTemplate
